import "./RecruiterNoteApplicantProfile.scss"

function RecruiterNoteApplicantProfile() {
    return (
        <div className='recruiterNoteApplicantProfile init-card'>
            <h4>Recruiter View</h4>
              <li>You are viewing a potential hire's profile page.</li>
              <li>Browse their skills, project, resume and contact them via email</li>
              </div>
    );
}

export default RecruiterNoteApplicantProfile;